export default "__VITE_ASSET__BrJY5dc6__"